export const PRESENTATION_HUB_ADMIN_ROUTE = '/crm/presentation-hub';
export const PRESENTATION_HUB_EDITOR_ROUTE = '/crm/presentation-hub/editor';

export const PRESENTATION_HUB_PUBLIC_ROUTES = [
  {
    id: 'ezerp-full',
    name: 'EzERP Full Presentation',
    publicPath: '/ezerp-full-presentation',
    sourceRoute: '/ezerp',
    sourceDeck: 'ezerp',
    status: 'ready',
    audience: 'Prospects, clients, and enterprise buyers',
    slideCount: 8,
    languages: ['en']
  },
  {
    id: 'ezerp-partner',
    name: 'EzERP Partner Presentation',
    publicPath: '/ezerp-partner-presentation',
    sourceRoute: '/ezerp-partners',
    sourceDeck: 'ezerp-partners',
    status: 'ready',
    audience: 'Implementation partners and strategic channels',
    slideCount: 11,
    languages: ['en', 'pt', 'es']
  },
  {
    id: 'emissor',
    name: 'Emissor Presentation',
    publicPath: '/emissor-presentation',
    sourceRoute: '/emissor',
    sourceDeck: 'emissor',
    status: 'ready',
    audience: 'Fiscal, NF-e, CT-e, and operations stakeholders',
    slideCount: 14,
    languages: ['en', 'pt']
  },
  {
    id: 'brazilian-rewards',
    name: 'Brazilian Rewards Presentation',
    publicPath: '/brazilian-rewards-presentation',
    sourceRoute: '/br',
    sourceDeck: 'brazilian-rewards',
    status: 'ready',
    audience: 'Brazilian Rewards launch and sponsor audience',
    slideCount: 10,
    languages: ['en', 'pt']
  },
  {
    id: 'full-stack-fiscal',
    name: 'The Full-Stack Fiscal Emission Platform',
    publicPath: '/full-stack-fiscal-platform',
    sourceRoute: '/full-stack-fiscal',
    sourceDeck: 'full-stack-fiscal',
    status: 'ready',
    audience: 'Fiscal, tax, and operations stakeholders',
    slideCount: 10,
    languages: ['en', 'pt', 'es']
  },
  {
    id: 'process-map',
    name: 'EzERP 3PL DC - Process Map',
    publicPath: '/process-map-presentation',
    sourceRoute: '/process-map',
    sourceDeck: 'process-map',
    status: 'ready',
    audience: '3PL, warehouse, and logistics operations',
    slideCount: 10,
    languages: ['en', 'pt', 'es']
  },
  {
    id: 'fiscal-emission',
    name: 'The Full-Stack Fiscal Emission Platform',
    publicPath: '/fiscal-emission-presentation',
    sourceRoute: '/fiscal-emission',
    sourceDeck: 'fiscal-emission',
    status: 'ready',
    audience: 'Fiscal, tax, and operations stakeholders',
    slideCount: 10,
    languages: ['en']
  },
  {
    id: 'fiscal-emission-v2',
    name: 'Fiscal Emission v2',
    publicPath: '/fiscal-emission-v2-presentation',
    sourceRoute: '/fiscal-emission-v2',
    sourceDeck: 'fiscal-emission-v2',
    status: 'ready',
    audience: 'Fiscal, tax, and operations stakeholders',
    slideCount: 10,
    languages: ['en', 'pt', 'es']
  },
  {
    id: 'emissor-crm',
    name: 'Emissor.PRO',
    publicPath: '/emissor-crm-presentation',
    sourceRoute: '/emissor-crm',
    sourceDeck: 'emissor-crm',
    status: 'ready',
    audience: 'Contábil tributária clients',
    slideCount: 7,
    languages: ['en', 'pt', 'es']
  },
  {
    id: 'emissor-crm-deep',
    name: 'Emissor.PRO (Deep)',
    publicPath: '/emissor-crm-deep-presentation',
    sourceRoute: '/emissor-crm-deep',
    sourceDeck: 'emissor-crm-deep',
    status: 'ready',
    audience: 'Technical experts',
    slideCount: 13,
    languages: ['en', 'pt', 'es']
  }
];

export function getPresentationRouteByPath(pathname) {
  return PRESENTATION_HUB_PUBLIC_ROUTES.find((route) => route.publicPath === pathname);
}

export function getPresentationRouteByDeck(sourceDeck) {
  return PRESENTATION_HUB_PUBLIC_ROUTES.find((route) => route.sourceDeck === sourceDeck);
}

export function getPresentationEditorPath(sourceDeck) {
  return `${PRESENTATION_HUB_EDITOR_ROUTE}/${sourceDeck}`;
}

export function getPresentationEditorPathByPublicPath(pathname) {
  const route = getPresentationRouteByPath(pathname);
  return route ? getPresentationEditorPath(route.sourceDeck) : PRESENTATION_HUB_ADMIN_ROUTE;
}
